<template>

  <div class="inner-box" style="display: flex;">


    <div class="content_a" style="margin-right: 10px; width: 50%">
      <div class="table-name">
        <h3 class="ico_table_name">모델정보</h3>
      </div>
      <div class="grid-wrap">
        <ag-grid-vue ref="productGrid"
                     style="width: 100%; height: 20vh;"
                     class="ag-theme-alpine grid_search_height"
                     rowSelection="single"
                     :columnDefs="columnDefs"
                     :gridOptions="gridOptions"
                     :rowData="data"
                     :defaultColDef="defaultColDef"
                     @grid-ready="onReadyProduct"
                     @selection-changed="onSelectionChangedProduct"
        />
      </div>
      <el-form size="mini" :model="form" ref="catInfoForm">

        <el-row>
          <el-col>
            <el-col :span="12">
              <el-form-item label="제조사">
                <el-input v-model="form.makerNm" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="제품군" prop="catNm">
                <el-input v-model="form.modelGroupNm" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="대표모델명">
                <el-input v-model="form.standardModelNm" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="모델명">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.modelNm" readonly></el-input>
                <el-button size="mini" type="primary" icon="el-icon-search" @click="searchModel"></el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="수량">
              <el-input v-model="form.modelQty"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div class="content_b" style="width: 50%">
      <div class="table-name">
        <h3 class="ico_table_name">제조번호정보</h3>
      </div>
      <div class="grid-wrap">
        <ag-grid-vue ref="grid-a"
                     style="width: 100%; height: 26vh;"
                     class="ag-theme-alpine grid_search_height"
                     rowSelection="single"
                     :columnDefs="columnDefsSub"
                     :gridOptions="gridOptionsSub"
                     :rowData="subData"
                     :defaultColDef="defaultColDefSub"
                     @selection-changed="onSelectionChangedModel"
        />
      </div>
      <el-form size="mini" :model="form" ref="catInfoForm">

        <el-row>
            <el-col :span="24">
              <el-form-item label="제조번호">
                <el-input v-model="form2.serialNo"></el-input>
              </el-form-item>
            </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="보증기간">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form2.guaranteeStartDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="　">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form2.guaranteeEndDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="설치일">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form2.setupDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
  </div>


</template>

<script>
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import _ from "lodash";

export default {
  name: "ProductInfo",
  props: ['custParam' , 'selectId'],
  data() {
    return {
      form: {
        companyId:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        maker:"",
        makerNm:"",
        modelGroup:"",
        modelGroupNm:"",
        modelId:"",
        modelNm:"",
        modelQty:"",
        siteId:"",
        siteModelInfoId:"",
        siteNm1:"",
        siteNm2:"",
        siteNm3:"",
        standardModelNm:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
      },
      form2:{
        companyId:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        guaranteeEndDt:"",
        guaranteeStartDt:"",
        maker:"",
        makerNm:"",
        modelCd:"",
        modelGroup:"",
        modelGroupNm:"",
        modelId:"",
        modelNm:"",
        serialNo:"",
        setupDt:"",
        siteId:"",
        siteModelId:"",
        siteModelInfoId:"",
        siteNm1:"",
        siteNm2:"",
        siteNm3:"",
        standardModelNm:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
      },
      defFormProduct:{
        companyId:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        guaranteeEndDt:"",
        guaranteeStartDt:"",
        maker:"",
        makerNm:"",
        modelCd:"",
        modelGroup:"",
        modelGroupNm:"",
        modelId:"",
        modelNm:"",
        serialNo:"",
        setupDt:"",
        siteId:"",
        siteModelId:"",
        siteModelInfoId:"",
        siteNm1:"",
        siteNm2:"",
        siteNm3:"",
        standardModelNm:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
      },
      columnDefs: [],
      columnDefsSub: [],
      gridOptions: {},
      gridOptionsSub: {},
      data: [],
      subData: [],
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      selectProductId:"",
    };
  },
  methods: {
    setSiteInfo() {
      Object.assign(this.data, this.custParam);
    },
    onReadyProduct(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

    },
    productInfo(siteModelInfoId){
      this.$http
          .post("/api/siteMng/item/info", {
            companyId: this.$store.state.loginInfo.compCd,
            siteId: this.selectId,
            siteModelInfoId: siteModelInfoId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.form = response.data[0];
            }
          }).finally(() => {
      });
    },
    modelList(siteModelInfoId){
      this.$http
          .post("/api/siteMng/model/list", {
            companyId: this.$store.state.loginInfo.compCd,
            siteId: this.selectId,
            siteModelInfoId: siteModelInfoId,
            sortType:"",
            processTime : ""
          })
          .then(response => {
            this.subData = response.data;
          }).finally(() => {
      });
    },
    modelInfo(siteModelId){
      this.$http
          .post("/api/siteMng/model/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            siteId: this.selectId,
            siteModelInfoId: this.selectProductId,
            siteModelId: siteModelId,
            sortType:"",
            processTime : ""
          })
          .then(response => {
            this.form2 = response.data[0];
          }).finally(() => {
      });
    },
    onSelectionChangedProduct() {
      this.gridApi = this.gridOptions.api;
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.selectProductId = voRow[0].siteModelInfoId;
      this.productInfo(this.selectProductId);
      this.modelList(this.selectProductId);
      this.form2 = _.clone(this.defFormProduct);
    },
    onSelectionChangedModel() {
      this.gridApi = this.gridOptionsSub.api;
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.modelInfo(voRow[0].siteModelId);
    },
    createColumnDefs() {
      const vm = this;

      this.columnDefs = [
        {headerName:'제조사', field:'makerNm', width:50, editable:false},
        {headerName:'제품군', field:'modelGroupNm', width:80, editable:false},
        {headerName:'모델명', field:'modelNm',  width:80, editable:false},
        {headerName:'수량', field:'modelQty', width:40, editable:false},
        {headerName:'', field:'siteModelInfoId', hide : true}
      ]

      this.columnDefsSub = [
        {headerName:'제조번호', field:'serialNo', width:50, editable:false},
        {headerName:'설치일', field:'setupDt', width:80, editable:false,
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {headerName: '보증기간',width:50, editable:false,
          children: [
            {headerName:'시작', field:'guaranteeEndDt', width:50, editable:false,
              valueFormatter: (params) => {
                return vm.getDateFormat(`${params.value}`)
              }
            },
            {headerName:'종료', field:'guaranteeStartDt', width:50, editable:false,
              valueFormatter: (params) => {
                return vm.getDateFormat(`${params.value}`)
              }
            },
          ]
        },
        {headerName:'', field:'siteModelInfoId', hide : true}
      ]

    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    searchModel(){
      /** 모델선택 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ModelSelectModal,
        parent: this,
        props: {
          data: {

          },
        },
        events: {
          close(param) {
            vm.form.maker = param.data.maker /** 제조사 */
            vm.form.makerNm = param.data.makerNm /** 제조사명 */
            vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
            vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
            vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
            vm.form.modelNm = param.data.modelNm /** 모델명 */
            vm.form.modelId = param.data.modelId /** 모델ID */
          },
        }
      });

    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

  },
  watch: {
    custParam() {
      this.data = this.custParam;
      this.setSiteInfo();
    },
    selectId(){
      this.setSiteInfo();
      this.createColumnDefs();
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

.el-form {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 25px 10px 25px;
  border-radius: 5px;
}
</style>